<template>
    <div v-if="isOpen" class="fixed inset-0 flex items-center justify-center z-50">
      <div class="absolute inset-0 bg-gray-800 opacity-50" @click="close"></div>
      <div class="bg-white p-4 sm:p-6 lg:p-8 rounded-lg shadow-lg z-10 w-full max-w-lg">
        <h2 class="text-xl sm:text-2xl font-bold mb-4 sm:mb-6 text-gray-800">Order Details</h2>
        <div>
          <p><strong>Order Date:</strong> {{ formatDate(order.createdAt) }}</p>
          <p><strong>Order Value:</strong> {{ formatCurrency(order.totalAmount) }}</p>
        
          <!-- Add more order details as needed -->
           <div v-if="orderItems" class="mt-4">
            <table class="min-w-full table-auto border-collapse">
            <thead>
              <tr class="bg-gray-200">
                <th class="p-2 sm:p-3 border text-left">Item</th>
                <th class="p-2 sm:p-3 border text-left">Quantity</th>
               
              </tr>
            </thead>
            <tbody>
              <tr v-for="order in this.orderItems" :key="order.id" class="bg-gray-50 hover:bg-gray-100">
                <td class="p-2 sm:p-3 border">{{ order.item.name}}</td>
                <td class="p-2 sm:p-3 border">{{ order.quantity }} {{order.item.unit }}</td>
              </tr>
            </tbody>
          </table>
                

           </div>
        </div>
        <div class="flex justify-end space-x-2 mt-4">
          <button type="button" @click="close" class="bg-gray-500 text-white p-2 rounded-lg hover:bg-gray-600">
            Close
          </button>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { mapActions,mapState } from 'vuex';
  export default {
    props: {
      isOpen: {
        type: Boolean,
        required: true
      },
      order: {
        type: Object,
        required: true
      }
    },

    mounted(){
       this.fetchItems()
    },
    computed : {
        ...mapState({
            orderItems: state => state.orderItems
        }),
    },
    methods: {
        ...mapActions(['fetchOrderItems']),
       fetchItems(){
         this.fetchOrderItems(this.order.id);
      },
      close() {
        this.$emit('close');
      },
      formatDate(date) {
        return new Date(date).toLocaleDateString();
      },
      formatCurrency(value) {
        return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'RwF' }).format(value);
      }
    }
  };
  </script>
  
  <style scoped>
  /* Optional: Add any custom styles here */
  </style>
  